export default {
  SET_ATTRIBUTE_MAPPINGS: 'setAttributeMappings',
  SET_SELECTED_ATTRIBUTE_MAPPING: 'setSelectedAttributeMapping',
  SET_FIELD_TENANTS: 'setFieldTenants',
  SET_FIELD_CUSTOMER_PROPERTIES: 'setFieldCustomProperties',
}